import { useDispatch } from "react-redux";
import { fetchTherapistProfileAction } from "store/actions/therapists";
import { toast } from "react-toastify";
import { useCurrentUser, useLogout } from "utils/hooks";

const useFetchTherapistProfile = () => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const fetchTherapistProfile = () => {
    return new Promise(() => {
      fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            query {
              getTherapistProfileByTherapistId {
                profileCredentials
                profileLicenseNumber
                profileLicensingState
              }
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_therapist_profiles",
        },
      })
        .then(async (res) => {
          if (res.status !== 200 && res.status !== 201) {
            const error = await res.json();
            if (error.errors[0].message.includes("BRKN_6001")) {
              toast.warn(`For security purposes please log in again.`);
              logOut();
            } else {
              toast.error(`Hmm, something went wrong.`);
              throw new Error("Failed!");
            }
          }
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            toast.error(
              `Hmm, something went wrong. ${resData.errors[0].message}`
            );
          } else {
            return dispatch(
              fetchTherapistProfileAction(
                resData.data.getTherapistProfileByTherapistId
              )
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  return {
    fetchTherapistProfile,
  };
};

export default useFetchTherapistProfile;
